<template lang="pug">
  .quiz-answer.card
    button.no(@click="answer(0)") No!
    button(@click="answer(1)") Hmm…
    button.yes(@click="answer(2)") Yes!
</template>

<script>
export default {
  name: 'QuizAnswer',
  methods: {
    answer(result) {
      this.$emit('done', result);
    }
  },
}
</script>

<style lang="stylus" scoped>
  .quiz-answer
    padding-top 75%
    display flex
    justify-content space-around
    flex-direction column
    button
      width 75%
      padding 8px
      font-size 12px
      &.no
        background-color rgba(111, 38, 13, .5)
      &.yes
        background-color rgba(38, 84, 16, .5)
</style>
